export const carbonNeutralModal = {
  CarbonNeutralShipping: "Carbon-neutral shipping",
  FullscriptTracks:
    "Fullscript tracks and calculates all emissions produced by shipping orders from our warehouses to your front door. We then offset these emissions by investing in high-quality carbon offset projects at no additional cost to you.",
  TheHealth:
    "The health of all people relies on the health of the planet. Thanks for committing to a more sustainable future!",
} as const;
